import React, { useMemo } from 'react'
import styled from 'styled-components'
import { QuadrantSelector } from '../input/quadrant/QuadrantSelector'
import { projectHelper } from '../../common/src/helpers'
import { withCyAttr } from '../../helpers/styleHelper'
import { CYPRESS_ID } from '../../constants/cypress'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

const Container = styled.div.attrs(withCyAttr())`
  display: flex;
  align-items: center;
  padding: 0 4px 0 4px;
`

const QuadrantName = styled.span`
  margin-left: 8px;
  vertical-align: middle;
  display: inline-block;
  flex-grow: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  &:empty::before {
    content: '\\200b'; /* unicode zero width space character */
  }
`

export const QuadrantMenuItem = ({ project, quadrant, quadrantSize = 18, text = '', ...rest }) => {
  const { t } = useTranslation()
  const name = useMemo(() => {
    if (text) {
      return text
    }
    if (project === 'keep' || !project) {
      return t('project.quadrant') + ' ' + (quadrant + 1)
    }
    return projectHelper.getSafeQuadrantName(project, quadrant)
  }, [project, quadrant, t, text])

  const cy = CYPRESS_ID.CREATE_QUADRANT(quadrant + 1)

  return (
    <Container cy={cy} {...rest}>
      {_.isNumber(quadrant) && (
        <QuadrantSelector
          size={quadrantSize}
          project={project === 'keep' ? undefined : project}
          quadrant={quadrant}
          isItem={true}
          readOnly={true}
        />
      )}
      <QuadrantName>{name}</QuadrantName>
    </Container>
  )
}
